// extracted by mini-css-extract-plugin
export var content = "styles-module--content--waMGA";
export var item = "styles-module--item--ihstg";
export var title = "styles-module--title--kY4lt";